const a=[
    {
		path: "goodList",
		component: () => import("@/views/mall/good/goodList.vue"),
		meta:{title:'商品列表',keepAlive:true},
	},
	{
		path: "goodEdit",
		component: () => import("@/views/mall/good/goodEdit.vue"),
		meta:{title:'商品编辑',keepAlive:false},
	},
	{
		path: "huashengList",
		component: () => import("@/views/mall/huasheng/huashengList.vue"),
		meta:{title:'花生甄选',keepAlive:false},
	},
	{
		path: "advertiseList",
		component: () => import("@/views/mall/advertise/advertiseList.vue"),
		meta:{title:'广告列表',keepAlive:true},
	},
	{
		path: "advertiseEdit",
		component: () => import("@/views/mall/advertise/advertiseEdit.vue"),
		meta:{title:'广告编辑',keepAlive:false},
	},
	
	{
		path: "selectList",
		component: () => import("@/views/mall/select/selectList.vue"),
		meta:{title:'甄选上新',keepAlive:false},
	},
   
]
export default a;